import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { TermsContext } from '#providers/terms/Terms.context.ts';
import type { TTermsContextValue } from '#providers/terms/Terms.types.ts';

export const useTerms = (): TTermsContextValue =>
  useRequiredContext(
    TermsContext,
    'useTerms is only available inside a TermsProvider',
  );
